module.exports = __webpack_public_path__ + "img/add_people_v2_grey.9b9a7326.svg";